import { api } from 'services/api';
import { Task, TasksList } from 'types';

export interface Payload {
  From: number;
  To: number;
}

interface ExactTaskPayload<T extends Task, P> {
  Type: T;
  Payload: P;
}

export type TaskPayload =
  | ExactTaskPayload<
      Task.md_print_z_report_by_date | Task.md_print_consolidated_report,
      { From: number; To: number }
    >
  | ExactTaskPayload<
      Task.md_print_z_report_by_num,
      { From: number; To: number }
    >;

export const deviceTasks = api
  .enhanceEndpoints({
    addTagTypes: ['DeviceTasks'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getDeviceTasks: build.query<TasksList, string>({
        query: (deviceId: string) => ({
          url: `/devices/${deviceId}/tasks`,
          method: 'GET',
        }),
        providesTags: (_res, _err, deviceId) => [
          { type: 'DeviceTasks', id: deviceId },
        ],
      }),
      createTasks: build.mutation<
        void,
        { deviceId: string; payload: TaskPayload }
      >({
        query: ({ deviceId, payload }) => ({
          url: `/devices/${deviceId}/tasks`,
          method: 'PUT',
          data: payload,
        }),
        invalidatesTags: (_res, _err, params) => [
          { type: 'DeviceTasks', id: params.deviceId },
        ],
      }),
    }),
  });

export const { useGetDeviceTasksQuery, useCreateTasksMutation } = deviceTasks;
